export default "38fcf25157c5ac5d.ttf"